//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
    name: "FabRightMenuItem",
    props: {
        label: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
        icon: { type: String, default: "mdi-chevron-left" },
        accent: { type: Boolean, default: false },
        mini: { type: Boolean },
        main: { type: Boolean },
        comments: { type: Boolean }
    },
    computed: {
        ...mapGetters("diagrams", ["getHasNewComments"]),
        classes() {
            const classes = [];

            if (this.main) { classes.push("main"); }
            if (this.accent) { classes.push("bg-red"); }

            return classes;
        }
    },
    methods: {
        itemClick() {
            this.$emit("click");
        }
    }
};
